/* eslint-disable */
const awsmobile = {
    "aws_project_region": "eu-west-1",

    "aws_cognito_identity_pool_id": "eu-west-1:d394afe0-eae9-4c54-a288-ad247a359012",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_NxtN4eRle",
    "aws_user_pools_web_client_id": "bodkao28if6q25e1o511o34na",
    "dynamodb": {
        "tables": {
            'FILE': 'brand-portal-app-production',
            'TAG': 'brand-portal-app-production-tags'
        }
    },
    "oauth": {
        "domain": "portal-auth.seenthis.co",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],

        "redirectSignIn": "https://portal.seenthis.co/",
        "redirectSignOut": "https://portal.seenthis.co/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],

    "aws_user_files_s3_bucket": "portal.seenthis.co",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
